import axios from "axios";
import { GET_FICHE_ENTETE_T } from "../../../constants/objectTye";

export const getFicheEntete = async(codeFueille : number)=>{
    try {
        const {data} : 
        {data: GET_FICHE_ENTETE_T[]} = await axios.get(`${process.env.REACT_APP_API_NDIAY_URL}/formfiche.php?code_feuille=${codeFueille}`);
        return data;
    } catch {
        return null
    }
}